import {setPageMessage} from '../../actions/pageMessageActions';
import {applyCreditAndGetOrderSummary} from '../../actions/paymentActions/accountCredit/accountCreditActions';
import {stopOrderProcessing} from '../../actions/site-actions';
import Language from '../../lang/language';
import getIsRecaptchaEnabled from '../../selectors/getIsRecaptchaEnabled';
import store from '../../store/store';

export default function orderStatusPollerFailed(response) {
  function deliveryOptionsError() {
    return typeof response === 'string' && response.indexOf('MISSING_DELIVERY_OPTIONS') > -1;
  }
  
  function klarnaCreditOptionsError() {
    return typeof response === 'string' && response.indexOf('cannot apply credit and pay with Klarna') > -1;
  }
  
  let placeOrderFailErrorMsg = Language.getText('errors.placeOrderFailError');
  
  if (typeof response !== 'undefined') {
    if (deliveryOptionsError()) {
      placeOrderFailErrorMsg = Language.getText('errors.placeOrderDelOptError');
    } else if (klarnaCreditOptionsError()) {
      placeOrderFailErrorMsg = Language.getText('errors.placeOrderKlarnaCreditError');
    } else if (response.status === 409) { // Conflict, customer doesn't have enough credit
      store.dispatch(applyCreditAndGetOrderSummary(0));
    }
  }
  
  if (getIsRecaptchaEnabled(store.getState()) && window.grecaptcha) {
    window.grecaptcha.reset();
  }
  
  store.dispatch(setPageMessage(placeOrderFailErrorMsg));
  store.dispatch(stopOrderProcessing());
}
